module.exports = __webpack_public_path__ + "static/media/54352673-8ca5-48ec-a479-62dcc3afab4c.986d9a4f.png";